import { render, staticRenderFns } from "./StaffsListSubPage.vue?vue&type=template&id=4a73009a&"
import script from "./StaffsListSubPage.vue?vue&type=script&lang=ts&"
export * from "./StaffsListSubPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports